export const DASHBOARD_REFRESH_STATE_EVENT = "flamex:dashboard-refresh-state";
export const DASHBOARD_REFRESH_REQUEST_EVENT = "flamex:dashboard-refresh-request";

export function publishDashboardRefreshState(state) {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new CustomEvent(DASHBOARD_REFRESH_STATE_EVENT, {
    detail: state || {},
  }));
}

// "00:30": rótulo da contagem regressiva exibida sob o ícone de atualizar da barra superior.
export function formatRefreshCountdown(value) {
  const totalSeconds = Math.max(0, Number(value) || 0);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

export function clearDashboardRefreshState() {
  publishDashboardRefreshState({
    visible: false,
    loading: false,
    countdown: null,
    countdownLabel: "",
  });
}

export function requestDashboardRefresh(options = {}) {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new CustomEvent(DASHBOARD_REFRESH_REQUEST_EVENT, {
    detail: options,
  }));
}
